import { render } from "./ProjectAttachProductComponent.vue?vue&type=template&id=588dcd66"
import script from "./ProjectAttachProductComponent.vue?vue&type=script&lang=js"
export * from "./ProjectAttachProductComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__